module.exports = {
      id: "vikatantv-usage",
      viewBox: "0 0 25.176 25.204",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#vikatantv",
      toString: function () {
        return this.url;
      }
    }